import { IObservable, Observable } from '@1js/oil-externals/rx';
import { SearchResultType } from '../search-instrumentation.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

/*
 * Data provider for more result.
 */
export class SeeMoreSuggestionProvider extends BaseSuggestionProvider {

    public static getButtonText: (searchText: string) => string;
    private static readonly oneDriveURL: string = 'https://onedrive.live.com/?id=root&qt=search&q=';

    public createStream(searchText: string): IObservable<any> {

        const result: Array<Object> = [];
        const renderedResults: Array<string> = [];

        if (searchText?.trim() !== '') {
            result.push({
                    isPwa: SeeMoreSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                    isDarkMode: SeeMoreSuggestionProvider.isDarkMode,
                    url: SeeMoreSuggestionProvider.oneDriveURL + searchText,
                    title: SeeMoreSuggestionProvider.getButtonText(searchText),
                    searchInstrumentationService: SeeMoreSuggestionProvider.searchInstrumentationService,
                    urlLauncherService: SeeMoreSuggestionProvider.urlLauncherService
                });
            renderedResults.push(SearchResultType.SeeMore);
        }

        SeeMoreSuggestionProvider.searchInstrumentationService.setRenderedProviderResults(SearchResultType.SeeMore, renderedResults);
        return Observable.fromArray(result);
    }

    public getId(): string {
        return 'seeMore';
    }
}
